import React from 'react'
import { createRoot } from 'react-dom/client'
import { Sdk, SdkConfig } from '@criptalia/sdk/src/Sdk'
import {
  getBestLang,
  setCurrentLang
} from '@criptalia/sdk/src/utils/translatorUtils'
import { FRONTEND_ENV } from './env'
import 'moment/dist/locale/it'
import 'moment/dist/locale/en-gb'
import 'moment/dist/locale/es'
import 'moment/dist/locale/fr'
import 'moment/dist/locale/de'
import 'moment/dist/locale/nl'
import 'moment/dist/locale/ca'
import 'dayjs/locale/en-gb'
import 'dayjs/locale/it'
import 'dayjs/locale/es'
import 'dayjs/locale/fr'
import 'dayjs/locale/de'
import 'dayjs/locale/nl'
import 'dayjs/locale/ca'

const App = React.lazy(() => import('./App'))

Sdk.init({
  env: FRONTEND_ENV,
  variables: {
    lang: {
      dev: ['en', 'it', 'es', 'fr', 'de', 'nl', 'ca'],
      prod: ['en', 'it', 'es', 'fr', 'de', 'nl', 'ca'],
    },
  },
  api: {
    baseUrl: import.meta.env.PROD ? FRONTEND_ENV.apiUrl : '/',
  },
} as Partial<SdkConfig>).then(() => {
  // Only after Sdk.init: before it the SDK's default language list (it/en/es)
  // applies, which reset fr/de/nl/ca to en and rewrote the lang cookie on
  // every page load.
  setCurrentLang(getBestLang())

  const container = document.getElementById('root')
  if (container) {
    const root = createRoot(container)
    root.render(
      <React.StrictMode>
        <React.Suspense fallback={<div>Loading...</div>}>
          <App />
        </React.Suspense>
      </React.StrictMode>
    )
  }
})
